import React, { useState, useEffect } from 'react';
import img from '../../src/assets/usr_bg2.jpg';
import { Link, useParams } from 'react-router-dom';
import Apiconnect from "../services/Apiconnect.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const StartPay = () => {
  const { id } = useParams(); // Get package ID from URL
  const [packageData, setPackageData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchPackageDetails(id);
    }
  }, [id]);

  const fetchPackageDetails = async (packageId) => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem('token');

      if (!token) {
        setError("Authentication token not found. Please login again.");
        toast.error("Authentication token not found. Please login again.");
        setIsLoading(false);
        return;
      }

      const response = await Apiconnect.getData(`package/${packageId}`);

      if (response.data && response.data.status === 'success') {
        setPackageData(response.data.data);
      } else {
        const errorMessage = response.data?.message || 'Failed to fetch package details';
        setError(errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching package details:", error);
      setError('An error occurred while fetching package details');
      toast.error('An error occurred while fetching package details');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div className="text-center mt-5">Loading package details...</div>;
  }

  if (error) {
    return <div className="alert alert-danger mt-5">{error}</div>;
  }

  if (!packageData) {
    return <div className="text-center mt-5">Package not found</div>;
  }

  const handleSubmit = async () => {

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error("Authentication token not found. Please login again.");
        return;
      }
      const inputData = {
        "name": packageData.name,
        "price": parseFloat(packageData.price).toLocaleString('en-IN'),
        "validity": packageData.pack_validity
      }
      const response = await Apiconnect.postDataWithToken("auth/send-package-upgrade-email", token, inputData);

      if (response.data && response.data.status === 1) {
        toast.success("Package Upgrade Request Successfully Sent To Admin");

      } else {
        toast.error(response.data?.message || "Failed to update customer.");
      }
    } catch (error) {
      console.error("General Error:", error);
      toast.error("An unexpected error occurred.");
    }
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-2 mb-4">
          <div className="col-md-12">
            <div className="card text-center">
              <div
                className="card-header"
                style={{
                  backgroundImage: `url(${img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                Payment Page - {packageData.name}
              </div>
              <div className="card-body">
                <h5 className="card-title mb-4">Complete Your Payment</h5>

                <div className="row justify-content-center mb-4">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h6 className="card-subtitle mb-3 text-muted">Package Details</h6>
                        <p><strong>Package:</strong> {packageData.name}</p>
                        <p><strong>Price:</strong> ₹{parseFloat(packageData.price).toLocaleString('en-IN')}</p>
                        <p><strong>Validity:</strong> {packageData.pack_validity} Days</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Here you would add your payment gateway integration */}

                <button onClick={handleSubmit} className="btn btn-primary" style={{ backgroundColor: '#072848', color: 'white' }}>
                  Request Admin to Upgrade
                </button>

              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default StartPay;